import ChangeEnum from "../../interfaces/frontend/ChangeEnum";
import { InhibitorDiffOptionsIndex } from "../InhibitorDiffOptions";

export default function InhibitorEmptyMessage(
  params: {
    showOnlySelected?: boolean,
    showOnlyAssociated?: boolean,
    differenceFilter?: ChangeEnum | null,
  },
  globalFilter: string | null
) {
  const showOnlySelected = params.showOnlySelected ?? false;
  const showOnlyAssociated = params.showOnlyAssociated ?? false;
  const differenceFilter = params.differenceFilter ?? null;

  const selected = showOnlySelected ? 'selected ' : '';
  const inhOrAssoc = showOnlyAssociated ? 'associated drugs' : 'inhibitors';
  let diff = '';
  if (differenceFilter !== null) {
    diff = ' with ' + InhibitorDiffOptionsIndex[ChangeEnum[differenceFilter]].label.toLowerCase();
  }
  const anyOrMatching = globalFilter ? `matching “${globalFilter}”` : 'found';
  return `No ${selected}${inhOrAssoc}${diff} ${anyOrMatching}.`

}
